import { useMemo } from "react";

const useMaskedPhoneNumber = (
  PhoneNumber: string,
  visibleStart = 1,
  visibleEnd = 3,
) => {
  const maskedNumber = useMemo(() => {
    const maskedSection = PhoneNumber.slice(visibleStart, -visibleEnd).replace(
      /\d/g,
      "*",
    );

    return (
      PhoneNumber?.slice(0, visibleStart) +
      maskedSection +
      PhoneNumber.slice(-visibleEnd)
    );
  }, [PhoneNumber, visibleStart, visibleEnd]);

  return maskedNumber;
};

export default useMaskedPhoneNumber;
